import * as C from 'io-ts/Codec';
import { ProjectListViewMode } from 'src/modules/project-list/types/ProjectListViewMode';

export const PROJECT_LIST_VIEW_MODE: C.Codec<unknown, string, ProjectListViewMode> = C.literal(
  ProjectListViewMode.LIST,
  ProjectListViewMode.GRID,
);
